import { MonthToWeek } from './constant';

const vipObj: any = {
  seeWhoLikedMe: 1,
  supreme: 2,
};
export const PERMISSION_PRY_TYPE = ['TWD', 'IDR', 'THB', 'MYR', 'USD'];

type Price = {
  id: string;
  currencySymbol: string;
  price: number;
  weeklyPrice: number;
  monthlyPrice: number;
  inAppWeeklyPrice: number;
  vipType: number;
  month: number;
  tagPrice: number;
  inAppMonthlyPrice: number;
};

export function filterPrice(data: any, tags: string[] = [], promotion = false): Price[] {
  if (!data?.length) return [];

  const validCategories = Object.keys(vipObj);

  return data
    .filter((item: any) => validCategories.includes(item.category))
    .map((item: any) => {
      const stockKeepUnit = promotion
        ? item.promotionStockKeepUnits?.[0] || item.discountStockKeepUnits?.[0] || item.defaultStockKeepUnits?.[0] || {}
        : item.defaultStockKeepUnits?.[0] || {};

      const prices = stockKeepUnit.prices || {};
      const tagPrice = prices.tagPrice || {};

      // Get price based on tags
      let price = tagPrice.default || 0;
      const matchingTag = tags?.find((tag) => tagPrice[tag] > 0);
      if (matchingTag) {
        price = tagPrice[matchingTag];
      }

      let weeklyPrice;
      let inAppWeeklyPrice;
      let monthlyPrice;
      let inAppMonthlyPrice;
      if (item.unit === 'days') {
        weeklyPrice = price;
        inAppWeeklyPrice = prices.inAppPrice;
      } else {
        weeklyPrice = (price / MonthToWeek[item.quantity]).toFixed(2);
        inAppWeeklyPrice = (prices.inAppPrice / MonthToWeek[item.quantity]).toFixed(2);
        monthlyPrice = (price / item.quantity).toFixed(2);
        inAppMonthlyPrice = (prices.inAppPrice / item.quantity).toFixed(2);
      }

      return {
        ...item,
        id: stockKeepUnit.id,
        currencySymbol: prices.currencySymbol,
        price,
        weeklyPrice,
        month: item.quantity,
        vipType: vipObj[item.category],
        inAppPrice: prices.inAppPrice,
        inAppWeeklyPrice,
        tagPrice,
        monthlyPrice,
        inAppMonthlyPrice,
      };
    });
}

export function addLink(text: string, text1: string, text2: string) {
  const res = text
    .replace(text1, `<a href="https://duetapp.net/privacy">${text1}</a>`)
    .replace(text2, `<a href="https://duetapp.net/terms">${text2}</a>`);
  return <div dangerouslySetInnerHTML={{ __html: res }} />;
}
